import { FC } from 'react';

import Image from 'next/image';

import { SFFooterViewModel } from '@api/index';

import { Wrapper, ImageWrapper } from './styled';

export type IFooterLogo = Pick<SFFooterViewModel, 'footerLogos'>;

const FooterCopyright: FC<IFooterLogo> = ({ footerLogos }) => {
  if (!footerLogos?.length) return null;
  return (
    <Wrapper>
      <ImageWrapper>
        {footerLogos?.map((item) => (
          <Image
            key={item?.image?.url ?? ''}
            src={item?.image?.url ?? '/static/images/placeholder-image.webp'}
            width={90}
            height={90}
            style={{
              objectFit: 'contain',
            }}
            alt={item?.image?.alt ?? 'Logo'}
          />
        ))}

        {footerLogos?.length && (
          <Image
            src='/static/icons/troy-logo.svg'
            alt='Troy'
            width={90}
            height={90}
            style={{
              objectFit: 'contain',
            }}
          />
        )}
      </ImageWrapper>
    </Wrapper>
  );
};

export default FooterCopyright;
